var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"anchor",attrs:{"name":_vm.anchor}}),_vm._v(" "),_c(`h${_vm.level}`,{tag:"component"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }